module.exports = __webpack_public_path__ + "img/pruning.f9d5e066.jpg";